import { render, staticRenderFns } from "./ArticleSelectCheckbox.vue?vue&type=template&id=1c128307&"
import script from "./ArticleSelectCheckbox.vue?vue&type=script&lang=js&"
export * from "./ArticleSelectCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports